import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useCallback, useEffect, useRef, useState } from "react";

function HorizontalScrollMedia({
  className = "",
  style = {},
  children,
  disableArrows = false,
}: {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  disableArrows?: boolean;
}) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  // Check if scrolling is possible
  const checkScroll = useCallback(() => {
    const container = scrollContainerRef.current;
    if (container) {
      setCanScrollLeft(container.scrollLeft > 0);
      setCanScrollRight(
        container.scrollLeft < container.scrollWidth - container.clientWidth
      );
    }
  }, []);

  // Scroll horizontally
  const scroll = useCallback((direction: "left" | "right") => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = container.offsetWidth * 0.8 * (direction === "left" ? -1 : 1);
      container.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  }, []);

  // Check scrolling on mount and when children change
  useEffect(() => {
    checkScroll();
  }, [children, checkScroll]);

  return (
    <div className="relative">
      <div onScroll={checkScroll} ref={scrollContainerRef} className={`relative flex w-full overflow-x-auto scroll-smooth space-x-2 mb-4 hide-scrollbar ${className}`} style={style}>
        {/* Scrollable Content Container */}
        <div
          className="flex overflow-x-auto scroll-smooth space-x-2 hide-scrollbar"
          style={{ minWidth: "max-content" }}
        >
          {children}
        </div>

      </div>
      {/* Scroll Controls */}
      {canScrollLeft && !disableArrows && (
        <button
          type="button"
          className="absolute left-2 top-1/2 transform -translate-y-1/2 z-50 rounded-full bg-black/60 backdrop-blur-md p-2"
          onClick={() => scroll("left")}
        >
          <ChevronLeft color="white" className="h-6 w-6" />
        </button>
      )}
      {canScrollRight && !disableArrows && (
        <button
          type="button"
          className="absolute right-2 top-1/2 transform -translate-y-1/2 z-50 rounded-full bg-black/60 backdrop-blur-md p-2"
          onClick={() => scroll("right")}
        >
          <ChevronRight color="white" className="h-6 w-6" />
        </button>
      )}
      {/* Left Gradient Fade */}
      {/* {canScrollLeft && !disableArrows && (
        <div className="absolute bg-red top-0 left-0 h-full w-8 bg-gradient-to-r from-background to-transparent pointer-events-none z-10 opacity-80"></div>
      )} */}

      {/* Right Gradient Fade */}
      {/* {canScrollRight && !disableArrows && (
        <div className="absolute top-0 right-0 h-full w-12 bg-gradient-to-l from-background to-transparent pointer-events-none z-10"></div>
      )} */}
    </div>
  );
}

export default HorizontalScrollMedia;